<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-card v-model="show" color="#FFFF99">
                    <v-card-title>
                        <v-icon large left>mdi-wrench-clock</v-icon>
                        <h6>Historial - Obligaciones Periódicas RRHH - {{ descr }}</h6>
                        <v-spacer></v-spacer>
                        <div>
                            <v-btn icon @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                </v-card>

                <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                    :items-per-page="2000">
                </v-data-table>
            </v-app>
        </div>
    </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        listado: [],
        showPlanilla: false,
        showEditar: false,

        headers: [
            {
                text: "Fecha",
                align: "center",
                sortable: false,
                value: "fecha",
            },
            { text: "Monto", value: "monto", sortable: false },
            { text: "O.P.", value: "frecuencia", sortable: false },
            { text: "Archivado en", value: "archivado", align: "center", sortable: false },
        ],
    }),

    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargarListados();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    props: ["visible", "codgral", "descr"],
    methods: {
        cargarListados() {
            this.vaciarModels();
            let self = this;

            axios
                .get("/RRHH/ListadoObligacionesRRHHHistorial?", {
                    params: {
                        codgral: self.codgral,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>